/**
 * Chromeless routes — pages that suppress the top `Header` bar and take the
 * full viewport height (Scout's document viewer, the Library/Chat surface,
 * Triage, relay-config, shared-chat). Shared by `ProtectedLayout` (to toggle
 * `hideHeader`) and the sidebar (to decide whether the account avatar lives in
 * the top-right slot vs. the rail footer) so the two never disagree.
 *
 * Match by exact path or path-prefix — e.g. `'/scout'` matches `/scout` and
 * `/scout/anything`.
 */
export const CHROMELESS_PATH_PREFIXES = [
  '/scout',
  '/library',
  '/home',
  '/inbox',
  '/admin/relay-config',
  '/chat/shared',
  '/procurement',
  '/quotes',
  // The Quote Desk home on a quotes-first build. Matches `/` exactly (a prefix of `//`
  // never occurs); on other builds `/` only redirects, so this is harmless there.
  '/',
] as const;

export function isChromelessPath(pathname: string): boolean {
  return CHROMELESS_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  );
}
